import { render, staticRenderFns } from "./ExtratoBancario.vue?vue&type=template&id=7aff8df5"
import script from "./ExtratoBancario.vue?vue&type=script&lang=js"
export * from "./ExtratoBancario.vue?vue&type=script&lang=js"
import style0 from "./ExtratoBancario.vue?vue&type=style&index=0&id=7aff8df5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports